<template>
  <b-form-group
    label="Teslim Tarihi"
    label-for="edate"
  >
    <b-form-datepicker
      id="edate"
      v-model="dataItem.edate"
      placeholder="Teslim Tarihi"
      v-bind="{labelNoDateSelected: 'Teslim Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
      locale="tr"
      start-weekday="1"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormDatepicker } from 'bootstrap-vue'

export default {
  name: 'EndDate',
  components: {
    BFormGroup,
    BFormDatepicker,
  },
  computed: {
    dataItem() {
      return this.$store.getters['services/dataItem']
    },
  },
}
</script>
